module.exports = __webpack_public_path__ + "img/video-9.39715ab0.png";